/* import __COLOCATED_TEMPLATE__ from './load-reg.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();